import { type ButtonHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "outline" | "ghost" | "danger";
  size?: "sm" | "md" | "lg";
}

export function Button({
  className,
  variant = "primary",
  size = "md",
  disabled,
  ...props
}: ButtonProps) {
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-md font-heading font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-teal focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none",
        {
          "bg-teal text-white hover:bg-teal/85": variant === "primary",
          "bg-card text-text border border-border hover:bg-sidebar":
            variant === "secondary",
          "border border-border bg-white text-text hover:bg-sidebar":
            variant === "outline",
          "text-text-muted hover:bg-sidebar hover:text-text":
            variant === "ghost",
          "bg-red-600 text-white hover:bg-red-700": variant === "danger",
        },
        {
          "px-3 py-1.5 text-xs": size === "sm",
          "px-4 py-2 text-sm": size === "md",
          "px-6 py-2.5 text-base": size === "lg",
        },
        className
      )}
      disabled={disabled}
      {...props}
    />
  );
}
